var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnitPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#DAFCB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8334 5H12.9843C12.6635 5 12.2152 5.18584 11.9886 5.41231L5.34046 12.0604C4.88651 12.5138 4.88651 13.2572 5.34046 13.7101L10.2905 18.66C10.7434 19.1134 11.4861 19.1134 11.9397 18.6595L18.5878 12.0124C18.8143 11.786 19.0001 11.3369 19.0001 11.0168V6.16673C19.0001 5.52517 18.4749 5 17.8334 5ZM15.4999 9.66674C14.8556 9.66674 14.3332 9.14382 14.3332 8.50001C14.3332 7.85514 14.8556 7.33328 15.4999 7.33328C16.1443 7.33328 16.6668 7.85514 16.6668 8.50001C16.6669 9.14382 16.1443 9.66674 15.4999 9.66674Z",
    fill: "#68C60B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitPrice);
export default __webpack_public_path__ + "static/media/unit-price.ad0b8b1b.svg";
export { ForwardRef as ReactComponent };